export const EMBEDDING_CHUNK_SIZE = 512;
export const EMBEDDING_CHUNK_OVERLAP = 8;
export const DEFAULT_VECTOR_MINIMUM_SCORE = 0.5;

export function isVectorSearch(filter: { vectorMinimumScore?: number }) {
	return typeof filter.vectorMinimumScore === 'number';
}
